export default "__VITE_ASSET__ZwshBjMk__"